.wrapper {
  background-color: #fff;
  border: 1px solid var(--color-easil-gray-x-light);
  border-radius: 4px;
  box-shadow: 0 2px 3px 0 rgba(28, 29, 30, 0.08);
  position: absolute;
  width: 300px;
  z-index: 30;
}
